/**
 * Subdomain SSO: warns when the user opened a different company's portal than last time (the current
 * subdomain differs from the `tenant_sub` cookie of the previous visit). Renders nothing when `show`
 * is false.
 *
 * @param {{ show: boolean, onDismiss: () => void }} props
 */
export function TenantWarningBanner({ show, onDismiss }) {
  if (!show) return null;

  return (
    <div
      role="alert"
      className="bg-amber-50 border-b border-amber-300 text-amber-900 px-4 py-3 text-sm flex items-start justify-between gap-4"
    >
      <span>
        You&apos;re signing in from a different company domain than last time. If this wasn&apos;t
        you, close this tab and return to your portal.
      </span>
      <button
        type="button"
        onClick={onDismiss}
        className="font-medium underline shrink-0"
        aria-label="Dismiss warning"
      >
        Dismiss
      </button>
    </div>
  );
}
